<div class="row tabs-cont" #tabsCont>
  <div class="col-md-12 h-100">
    <ngb-tabset #tabSet="ngbTabset" [destroyOnHide]="false" id="tabset">
      <ngb-tab title="{{'ACTION.PODESAVANJEAKCIJA.USERS.PLURAL'| translate}}" id="tbList">
        <ng-template ngbTabContent>
          <form [formGroup]="formGroupUser" #f="ngForm" class="mt-4 pl-2">
            <div class="row">
              <div class="col-lg-2">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-dropdown-picklist
                        #zaposleniDropdown 
                        [ModelName]="'user'" 
                        [GetName]="'get'"
                        [ModelProperty]="'FirstName'"
                        [AllowAddNew]="false"
                        [AllowEdit]="false" 
                        formControlName="UserID"
                        [Label]="'ACTION.PODESAVANJEAKCIJA.KORISNIK.SINGULAR'"
                        [AutoSelect]="true"
                        [TableColumns]="[{ name: 'FirstName', label: 'Ime', visible: true, canHide: true },
                        { name: 'LastName', label: 'Prezime', visible: true, canHide: true}]"
                        (OnItemSelected)="OnUserSelected($event)">
                    </yt-dropdown-picklist>
                  </div>
                </div>
              </div>
              <div class="col-lg-2">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-dropdown-picklist 
                    [ModelName]="'userrole'" 
                    [GetName]="'get'" 
                    [ModelProperty]="'Name'"
                    [OrderBy]="'Name'" 
                    [AllowAddNew]="false" 
                    formControlName="RoleID"
                    name="cmbUserRole"
                    [Label]="'ACTION.PODESAVANJEAKCIJA.ROLA.SINGULAR'">
                    </yt-dropdown-picklist>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-dropdown-picklist 
                    [ModelName]="'orgjed'" 
                    [GetName]="'getByUserID'" 
                    [GetParameters]="parameterListUser" 
                    [ModelProperty]="'Naziv'"
                    [OrderBy]="'Naziv'" 
                    [AllowAddNew]="false" 
                    [AllowEdit]="false" 
                    formControlName="OrgJedID"
                    [Label]="'ACTION.PODESAVANJEAKCIJA.ORGJEDID.SINGULAR'">
                    </yt-dropdown-picklist>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-dropdown-picklist 
                    [ModelName]="'firma'" 
                    [GetName]="'getByUserID'"
                    [GetParameters]="parameterListUser" 
                    [ModelProperty]="'Naziv'" 
                    formControlName="FirmaID"
                    [Label]="'ACTION.PODESAVANJEAKCIJA.FIRMA.SINGULAR'" 
                    [ngClass]="{'is-invalid': submitted && fc.FirmaID.invalid}"
                    [Position]="'left'" 
                    [AutoSelect]="'true'"
                    [AllowAddNew]="false" 
                    [AllowEdit]="false" 
                    [TableColumns]="[{ name: 'SNaziv', label: 'FIRMA.SNAZIV.SINGULAR', visible: true, canHide: false }]">>
                    </yt-dropdown-picklist>
                  </div>
                </div>
              </div>
              <div class="col-lg-2">
                <button class="btn btn-outline-primary" (click)="GetDataUserAction(formGroupUser.get('UserID').value, formGroupUser.get('RoleID').value)">Primeni filter</button>
              </div>
            </div>
            <table>
              <thead style="text-align: center;">
                <tr>
                  <th>MODEL</th>
                  <th>NAZIV</th>
                  <th>VREDNOST ROLA</th>
                  <th>VREDNOST KORISNIK</th>
                </tr>
              </thead>
              <tbody formArrayName="resultUser" style="text-align: center;">
                <tr *ngFor="let res of formGroupUser.get('resultUser')['controls']; let i = index" [formGroupName]="i">
                  <td style="padding-right: 20px">{{ res.get('Model').value }}</td>
                  <td style="padding-right: 20px">{{ res.get('Naziv').value }}</td>                
                  <td style="padding-right: 30px">{{ res.get('VrednostRola').value }}</td>
                  <td><input #vrednostKorisnikCheckbox type="checkbox" formControlName="VrednostKorisnik" (change)="onVrednostUserChange($event.target.checked, res.get('ID').value, i)"></td>
                </tr>
              </tbody>
             </table>
            </form>
        </ng-template>
      </ngb-tab>
      <ngb-tab title="{{'ACTION.PODESAVANJEAKCIJA.ROLES.PLURAL'| translate}}" id="tbEmail">
        <ng-template ngbTabContent>
          <div class="row">
            <div class="col-md-12">
              <form [formGroup]="formGroupRole" #f="ngForm" class="mt-4 pl-2">
                <div class="row">
                  <div class="col-lg-2">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <yt-dropdown-picklist 
                        [ModelName]="'userrole'" 
                        [GetName]="'get'" 
                        [ModelProperty]="'Name'"
                        [OrderBy]="'Name'" 
                        [AllowAddNew]="false"
                        formControlName="RoleID"
                        name="cmbUserRole"
                        [Label]="'ACTION.PODESAVANJEAKCIJA.ROLA.SINGULAR'">
                        </yt-dropdown-picklist>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2">
                    <button class="btn btn-outline-primary" (click)="GetDataRoleAction(formGroupRole.get('RoleID').value)">Primeni filter</button>
                    <button type="button" class="btn btn-outline-primary" (click)="OnAddActionRole()" ngbTooltip="{{'FW.ACTION.ADD.ACTION' | translate }}" container="body"><span class="fa fa-fw fa-plus"></span></button>
                  </div>
                </div>
                <table>
                  <thead style="text-align: center;">
                    <tr>
                      <th>MODEL</th>
                      <th>NAZIV</th>
                      <th>VREDNOST ROLA</th>
                    </tr>
                  </thead>
                  <tbody formArrayName="resultRole" style="text-align: center;">
                    <tr *ngFor="let res of formGroupRole.get('resultRole')['controls']; let i = index" [formGroupName]="i">
                      <td style="padding-right: 20px">{{ res.get('Model').value }}</td>
                      <td style="padding-right: 20px">{{ res.get('Naziv').value }}</td>                
                      <td><input type="checkbox" formControlName="VrednostRola" (change)="onVrednostRoleChange($event.target.checked, res.get('ID').value)"></td>
                    </tr>
                  </tbody>
                 </table>
                </form>
            </div>
          </div>
        </ng-template>
      </ngb-tab>
      <ngb-tab title="{{'ACTION.PODESAVANJEAKCIJA.ACTION.PLURAL'| translate}}" id="tbTelefon">
        <ng-template ngbTabContent>
          <div class="row">
            <div class="col-md-12">
              <!-- <form [formGroup]="formGroupAction" #f="ngForm" class="mt-4 pl-2">
              <table>
                <thead style="text-align: center;">
                  <tr>
                    <th>MODEL</th>
                    <th>NAZIV</th>
                    <th>VREDNOST</th>
                  </tr>
                </thead>
                <tbody formArrayName="resultAction" style="text-align: center;">
                  <tr *ngFor="let res of formGroupAction.get('resultAction')['controls']; let i = index" [formGroupName]="i">
                    <td style="padding-right: 20px">{{ res.get('Model').value }}</td>
                    <td style="padding-right: 20px">{{ res.get('Naziv').value }}</td>                
                    <td><input type="checkbox" formControlName="DefaultValue" (change)="onVrednostActionChange($event.target.checked, res)"></td>
                  </tr>
                </tbody>
               </table>
              </form> -->
              <yt-fw-default-list-modal [CondensedTable]="true" #defaultList></yt-fw-default-list-modal>
            </div>
          </div>
        </ng-template>
      </ngb-tab>
    </ngb-tabset>
  </div>
</div>